﻿// Collection Product Cards functionality - matching home page behavior
(function() {
  window.SevenRealmsPageLocalSearchOwnedByCards = false;

  function formatMoney(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: window.shopCurrency || 'USD',
      minimumFractionDigits: 2
    }).format(Number(cents || 0) / 100);
  }

  function getOrCreateChip(card, selector, attrName) {
    let chip = card.querySelector(selector);
    const meta = card.querySelector('.collection-variant-meta');
    if (!chip && meta) {
      chip = document.createElement('span');
      chip.className = 'collection-variant-chip';
      chip.setAttribute(attrName, '');
      const stockChip = meta.querySelector('[data-variant-stock]');
      meta.insertBefore(chip, stockChip || null);
    }
    return chip;
  }

  function updateOptionalChip(card, selector, attrName, value) {
    const chip = getOrCreateChip(card, selector, attrName);
    if (!chip) return null;

    if (value) {
      chip.textContent = value;
      chip.hidden = false;
    } else {
      chip.hidden = true;
      chip.textContent = '';
    }

    return chip;
  }

  const conditionClasses = [
    'collection-variant-chip--condition-nm',
    'collection-variant-chip--condition-lp',
    'collection-variant-chip--condition-mp',
    'collection-variant-chip--condition-hp',
    'collection-variant-chip--condition-damaged'
  ];
  const languageClasses = [
    'collection-variant-chip--jp',
    'collection-variant-chip--kr',
    'collection-variant-chip--cn',
    'collection-variant-chip--de',
    'collection-variant-chip--fr',
    'collection-variant-chip--es',
    'collection-variant-chip--it',
    'collection-variant-chip--pt'
  ];

  function deriveLanguage(condition, explicitLanguage) {
    const explicit = String(explicitLanguage || '').trim();
    const text = `${explicit} ${condition || ''}`.toLowerCase();

    if (text.includes('japanese') || /\bjp\b/.test(text)) return 'JP';
    if (text.includes('korean') || /\bkr\b/.test(text)) return 'KR';
    if (text.includes('chinese') || /\bcn\b/.test(text) || /\bzh\b/.test(text)) return 'CN';
    if (text.includes('german') || /\bde\b/.test(text)) return 'DE';
    if (text.includes('french') || /\bfr\b/.test(text)) return 'FR';
    if (text.includes('spanish') || /\bes\b/.test(text)) return 'ES';
    if (text.includes('italian') || /\bit\b/.test(text)) return 'IT';
    if (text.includes('portuguese') || /\bpt\b/.test(text)) return 'PT';
    return explicit;
  }

  function cleanConditionText(value) {
    const original = String(value || '').trim();
    const cleaned = original
      .replace(/\s*\/\s*(japanese|jp)\s*\/\s*/ig, ' / ')
      .replace(/\s*[-/]\s*(japanese|korean|chinese|german|french|spanish|italian|portuguese|jp|kr|cn|zh|de|fr|es|it|pt)\b/ig, '')
      .replace(/\b(japanese|korean|chinese|german|french|spanish|italian|portuguese|jp|kr|cn|zh|de|fr|es|it|pt)\s*[-/]\s*/ig, '')
      .replace(/\b(Japanese|Korean|Chinese|German|French|Spanish|Italian|Portuguese)\b/ig, '')
      .replace(/\b(JP|KR|CN|ZH|DE|FR|ES|IT|PT)\b/g, '')
      .replace(/\s*\/\s*/g, ' / ')
      .replace(/\s{2,}/g, ' ')
      .replace(/^\s*[-/]\s*|\s*[-/]\s*$/g, '')
      .trim();

    return cleaned || original;
  }

  function abbreviateConditionText(value) {
    const text = String(value || '').trim();
    const lower = text.toLowerCase();

    if (lower.includes('damaged') || /\bdmg\b/.test(lower)) return 'DMG';
    if (lower.includes('heavily played') || /\bhp\b/.test(lower)) return 'HP';
    if (lower.includes('moderately played') || /\bmp\b/.test(lower)) return 'MP';
    if (lower.includes('lightly played') || /\blp\b/.test(lower)) return 'LP';
    if (lower.includes('near mint') || /\bnm\b/.test(lower)) return 'NM';
    if (lower.includes('played')) return 'PL';

    return text;
  }

  function getConditionClass(value) {
    const text = String(value || '').toLowerCase();

    if (text.includes('damaged')) return 'collection-variant-chip--condition-damaged';
    if (text.includes('heavily played') || /\bhp\b/.test(text)) return 'collection-variant-chip--condition-hp';
    if (text.includes('moderately played') || /\bmp\b/.test(text)) return 'collection-variant-chip--condition-mp';
    if (text.includes('lightly played') || /\blp\b/.test(text)) return 'collection-variant-chip--condition-lp';
    if (text.includes('near mint') || /\bnm\b/.test(text)) return 'collection-variant-chip--condition-nm';
    return '';
  }

  function applyConditionStyle(chip, value, isFoil) {
    if (!chip) return;
    chip.classList.remove(...conditionClasses);
    const conditionClass = getConditionClass(value);
    if (conditionClass) chip.classList.add(conditionClass);
    chip.classList.toggle('collection-variant-chip--foil', Boolean(isFoil));
  }

  function applyLanguageStyle(chip, value) {
    if (!chip) return;
    const text = String(value || '').toLowerCase();
    const code = String(value || '').trim().toUpperCase();
    chip.classList.toggle('collection-variant-chip--language', Boolean(value));
    chip.classList.remove(...languageClasses);
    chip.classList.toggle('collection-variant-chip--jp', text.includes('jp') || text.includes('japanese'));
    chip.classList.toggle('collection-variant-chip--kr', text.includes('kr') || text.includes('korean'));
    chip.classList.toggle('collection-variant-chip--cn', text.includes('cn') || text.includes('zh') || text.includes('chinese'));
    chip.classList.toggle('collection-variant-chip--de', text.includes('de') || text.includes('german'));
    chip.classList.toggle('collection-variant-chip--fr', text.includes('fr') || text.includes('french'));
    chip.classList.toggle('collection-variant-chip--es', text.includes('es') || text.includes('spanish'));
    chip.classList.toggle('collection-variant-chip--it', text.includes('it') || text.includes('italian'));
    chip.classList.toggle('collection-variant-chip--pt', text.includes('pt') || text.includes('portuguese'));
    chip.setAttribute('data-language-code', code);
  }

  function decorateVariantChips(root = document) {
    const cards = root.querySelectorAll ? root.querySelectorAll('.collection-product-card') : [];

    cards.forEach((card) => {
      const conditionChip = card.querySelector('[data-variant-condition]');
      if (!conditionChip) return;

      const rawCondition = conditionChip.textContent || '';
      const language = deriveLanguage(rawCondition, card.querySelector('[data-variant-language]')?.textContent || '');
      const cleanCondition = cleanConditionText(rawCondition);
      const isFoil = cleanCondition.toLowerCase().includes('foil') || cleanCondition.toLowerCase().includes('holo');

      conditionChip.textContent = abbreviateConditionText(cleanCondition);
      applyConditionStyle(conditionChip, cleanCondition, isFoil);

      const languageChip = updateOptionalChip(card, '[data-variant-language]', 'data-variant-language', language);
      applyLanguageStyle(languageChip, language);

      const foilChip = card.querySelector('[data-variant-foil]');
      if (foilChip) {
        foilChip.hidden = true;
        foilChip.textContent = '';
      }
    });
  }

  function updateVariantMeta(card, selectedOption) {
    const conditionChip = card.querySelector('[data-variant-condition]');
    const rawCondition = selectedOption.dataset.condition || selectedOption.textContent || '';
    const conditionText = cleanConditionText(rawCondition);
    const language = deriveLanguage(rawCondition, selectedOption.dataset.language);
    const isFoil = Boolean(selectedOption.dataset.foil) || conditionText.toLowerCase().includes('foil') || conditionText.toLowerCase().includes('holo');

    if (conditionChip && conditionText) {
      conditionChip.textContent = abbreviateConditionText(conditionText);
      applyConditionStyle(conditionChip, conditionText, isFoil);
    }

    const languageChip = updateOptionalChip(card, '[data-variant-language]', 'data-variant-language', language);
    applyLanguageStyle(languageChip, language);
    const foilChip = card.querySelector('[data-variant-foil]');
    if (foilChip) {
      foilChip.hidden = true;
      foilChip.textContent = '';
    }

    const stockChip = card.querySelector('[data-variant-stock]');
    if (stockChip) {
      stockChip.textContent = selectedOption.dataset.stockLabel || 'In stock';
      stockChip.classList.remove('collection-variant-chip--stock', 'collection-variant-chip--critical', 'collection-variant-chip--low', 'collection-variant-chip--out');
      stockChip.classList.add(`collection-variant-chip--${selectedOption.dataset.stockClass || 'stock'}`);
    }
  }

  function syncVariantPills(card, variantId) {
    if (!card) return;
    card.querySelectorAll('.collection-variant-pill').forEach((pill) => {
      const active = pill.dataset.variantId === String(variantId);
      pill.classList.toggle('is-active', active);
      pill.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function initCollectionProductCards(root = document) {
  applyCurrentPageSort(root);
  decorateVariantChips(root);

  // Handle variant selection
  const variantSelects = root.querySelectorAll('.collection-variant-select');
  
  variantSelects.forEach(select => {
    if (select.dataset.collectionCardBound === 'true') return;
    select.dataset.collectionCardBound = 'true';

    select.addEventListener('change', function() {
      const scrollX = window.scrollX;
      const scrollY = window.scrollY;
      const selectedOption = this.options[this.selectedIndex];
      const variantId = selectedOption.value;
      const price = selectedOption.dataset.price;
      const image = selectedOption.dataset.image;
      
      const card = this.closest('.collection-product-card');
      if (!card) return;
      syncVariantPills(card, variantId);
      
      // Update price
      const priceElement = card.querySelector('.collection-product-price');
      if (priceElement && price) {
        priceElement.textContent = formatMoney(price);
        priceElement.dataset.price = price;
      }

      updateVariantMeta(card, selectedOption);
      
      // Update image if variant has one
      const productImage = card.querySelector('.collection-product-image');
      if (productImage && image) {
        productImage.src = image;
      }
      
      // Update add to cart button variant ID
      const addToCartBtn = card.querySelector('.collection-add-to-cart-btn');
      if (addToCartBtn) {
        addToCartBtn.dataset.variantId = variantId;
        const available = selectedOption.dataset.available === 'true';
        addToCartBtn.disabled = !available;
        addToCartBtn.setAttribute('aria-disabled', available ? 'false' : 'true');
        addToCartBtn.textContent = available ? 'Add to Cart' : 'Sold Out';
      }

      card.dataset.sortPrice = price || '0';
      requestAnimationFrame(() => window.scrollTo(scrollX, scrollY));
      window.setTimeout(() => window.scrollTo(scrollX, scrollY), 0);
    });
  });

  const variantPills = root.querySelectorAll('.collection-variant-pill');
  variantPills.forEach((pill) => {
    if (pill.dataset.collectionPillBound === 'true') return;
    pill.dataset.collectionPillBound = 'true';

    pill.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const scrollX = window.scrollX;
      const scrollY = window.scrollY;

      const card = this.closest('.collection-product-card');
      const select = card ? card.querySelector('.collection-variant-select') : null;
      if (!select) return;

      select.value = this.dataset.variantId;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      requestAnimationFrame(() => window.scrollTo(scrollX, scrollY));
      window.setTimeout(() => window.scrollTo(scrollX, scrollY), 0);
    });
  });
  
  // Handle add to cart functionality
  const addToCartButtons = root.querySelectorAll('.collection-add-to-cart-btn');
  
  addToCartButtons.forEach(button => {
    if (button.dataset.collectionCardBound === 'true') return;
    button.dataset.collectionCardBound = 'true';

    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const variantId = this.dataset.variantId;
      
      if (!variantId) {
        console.error('No variant ID found');
        return;
      }

      if (this.disabled || this.getAttribute('aria-disabled') === 'true') return;
      
      // Add loading state
      this.classList.add('loading');
      this.disabled = true;
      
      // Add to cart
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(response => response.json())
      .then(data => {
        // Remove loading state
        this.classList.remove('loading');
        this.disabled = false;
        
        if (data.status && data.status === 422) {
          // Handle error (out of stock, etc.)
          alert(data.description || 'Unable to add item to cart');
        } else {
          // Success - update cart
          this.textContent = 'Added!';
          setTimeout(() => {
            this.textContent = 'Add to Cart';
          }, 2000);

          refreshCartUi();
        }
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        this.classList.remove('loading');
        this.disabled = false;
        alert('Error adding item to cart. Please try again.');
      });
    });
  });
  
  // Prevent clicks on variant selectors from triggering product link
  const variantSelectors = root.querySelectorAll('.collection-variant-selector');
  variantSelectors.forEach(selector => {
    if (selector.dataset.collectionSelectorBound === 'true') return;
    selector.dataset.collectionSelectorBound = 'true';

    selector.addEventListener('click', function(e) {
      e.stopPropagation();
    });
  });
  
  // Prevent clicks on buttons from triggering product link
  const buttons = root.querySelectorAll('.collection-add-to-cart-btn');
  buttons.forEach(button => {
    if (button.dataset.collectionButtonStopBound === 'true') return;
    button.dataset.collectionButtonStopBound = 'true';

    button.addEventListener('click', function(e) {
      e.stopPropagation();
    });
  });
  }

  function applyCurrentPageSort(root = document) {
    const sortSelect = document.getElementById('SortBy');
    const container = root.querySelector ? root.querySelector('#product-grid') : document.getElementById('product-grid');
    if (!sortSelect || !container) return;

    const sortValue = sortSelect.value || '';
    const isPriceSort = sortValue.includes('price-');
    const isTitleSort = sortValue.includes('title-') || sortValue.includes('name-');
    if (!isPriceSort && !isTitleSort) return;

    const grid = container.matches && container.matches('.product-grid') ? container : container.querySelector('.product-grid');
    if (!grid) return;

    const items = Array.from(grid.querySelectorAll(':scope > .grid__item'));
    if (items.length < 2) return;

    const direction = sortValue.includes('descending') ? -1 : 1;
    items
      .sort((a, b) => {
        const aCard = a.querySelector('.collection-product-card');
        const bCard = b.querySelector('.collection-product-card');

        if (isTitleSort) {
          const aTitle = (aCard?.dataset.sortTitle || aCard?.querySelector('.collection-product-title')?.textContent || '').trim().toLowerCase();
          const bTitle = (bCard?.dataset.sortTitle || bCard?.querySelector('.collection-product-title')?.textContent || '').trim().toLowerCase();
          return aTitle.localeCompare(bTitle, undefined, { numeric: true, sensitivity: 'base' }) * direction;
        }

        const aPrice = Number(aCard?.dataset.sortPrice || 0);
        const bPrice = Number(bCard?.dataset.sortPrice || 0);
        return (aPrice - bPrice) * direction;
      })
      .forEach((item) => grid.appendChild(item));
  }

  function getCurrentStockMode() {
    const params = new URLSearchParams(window.location.search);
    const availability = params.get('filter.v.availability');
    if (params.get('stock') === 'all') return 'all';
    if (availability === '0' || availability === 'false') return 'sold-out';
    return 'in-stock';
  }

  function getPageSearchQuery() {
    const input = document.querySelector('[data-page-product-search]');
    return input ? input.value.trim().toLowerCase() : '';
  }

  function applyPageVisibility(root = document) {
    const grid = root.matches?.('#product-grid')
      ? root
      : (root.querySelector ? root.querySelector('#product-grid') : document.getElementById('product-grid'));
    if (!grid) return;

    const mode = getCurrentStockMode();
    const query = getPageSearchQuery();

    const items = Array.from(grid.querySelectorAll('.grid__item'));
    let visibleCount = 0;
    items.forEach((item) => {
      const card = item.querySelector('.collection-product-card');
      if (!card) return;
      const stock = item.dataset.productStock || card.dataset.productStock || 'in-stock';
      const title = (card.dataset.sortTitle || card.querySelector('.collection-product-title')?.textContent || '').trim().toLowerCase();
      const stockMismatch = mode !== 'all' && stock !== mode;
      const queryMismatch = Boolean(query) && !title.includes(query);
      item.hidden = stockMismatch || queryMismatch;
      if (!item.hidden) visibleCount += 1;
    });

    document.querySelectorAll('[data-page-filter-status]').forEach((status) => {
      status.textContent = query
        ? `${visibleCount} of ${items.length} shown products match “${query}”.`
        : `Showing ${visibleCount} of ${items.length} products loaded on this page.`;
    });
  }

  function applyStockFilterFallback(root = document) {
    const buttons = Array.from(document.querySelectorAll('.collection-stock-filter__link[data-stock-mode]'));
    const grid = root.matches?.('#product-grid')
      ? root
      : (root.querySelector ? root.querySelector('#product-grid') : document.getElementById('product-grid'));
    if (!buttons.length || !grid) return;

    const mode = getCurrentStockMode();

    buttons.forEach((button) => {
      const active = button.dataset.stockMode === mode;
      button.classList.toggle('is-active', active);
      if (active) button.setAttribute('aria-current', 'true');
      else button.removeAttribute('aria-current');
    });

    applyPageVisibility(root);
  }

  function initStockFilterLinks(root = document) {
    const links = root.querySelectorAll ? root.querySelectorAll('.collection-stock-filter__link[data-stock-mode]') : [];
    links.forEach((link) => {
      if (link.dataset.stockFilterBound === 'true') return;
      link.dataset.stockFilterBound = 'true';

      link.addEventListener('click', (event) => {
        event.preventDefault();
        const mode = link.dataset.stockMode || 'in-stock';
        const url = new URL(window.location.href);

        url.searchParams.delete('page');
        url.searchParams.delete('stock');
        url.searchParams.delete('filter.v.availability');

        if (mode === 'all') {
          url.searchParams.set('stock', 'all');
        } else if (mode === 'sold-out') {
          url.searchParams.set('filter.v.availability', '0');
        } else {
          url.searchParams.set('filter.v.availability', '1');
        }

        window.location.href = url.toString();
      });
    });
  }

  function initPageLocalSearch(root = document) {
    const inputs = root.querySelectorAll ? root.querySelectorAll('[data-page-product-search]') : [];
    inputs.forEach((input) => {
      if (input.dataset.pageSearchBound === 'true') return;
      input.dataset.pageSearchBound = 'true';

      const wrap = input.closest('.collection-page-search, .search-page-inline-tools') || input.parentElement;
      let suggestions = wrap ? wrap.querySelector('.page-search-suggestions') : null;
      if (!suggestions && wrap) {
        suggestions = document.createElement('div');
        suggestions.className = 'page-search-suggestions';
        suggestions.setAttribute('role', 'listbox');
        suggestions.hidden = true;
        wrap.appendChild(suggestions);
      }

      const getCards = () => Array.from(document.querySelectorAll('#product-grid .collection-product-card'));
      const getTitle = (card) => (card.getAttribute('data-sort-title') || card.querySelector('.collection-product-title')?.textContent || '').trim();
      const setVisible = () => applyPageVisibility(document);
      const focusMatch = (card) => {
        if (!card) return;
        card.scrollIntoView({ block: 'center', behavior: 'smooth' });
        card.classList.add('is-page-search-match');
        window.setTimeout(() => card.classList.remove('is-page-search-match'), 1400);
      };

      const executeSearch = () => {
        setVisible();
        renderSuggestions();
        const query = input.value.trim().toLowerCase();
        const firstMatch = getCards().find((card) => {
          const title = getTitle(card).toLowerCase();
          const wrapper = card.closest('#product-grid > .grid__item');
          return !wrapper?.hidden && (!query || title.includes(query));
        });
        focusMatch(firstMatch);
      };

      input.sevenRealmsRunPageSearch = executeSearch;

      const renderSuggestions = () => {
        if (!suggestions) return;
        const query = input.value.trim().toLowerCase();
        suggestions.innerHTML = '';
        if (query.length < 2) {
          suggestions.hidden = true;
          return;
        }

        const matches = getCards()
          .map((card) => ({ card, title: getTitle(card) }))
          .filter((item) => item.title.toLowerCase().includes(query))
          .slice(0, 8);

        if (!matches.length) {
          const empty = document.createElement('div');
          empty.className = 'page-search-suggestion page-search-suggestion--empty';
          empty.textContent = 'No products found on this page';
          suggestions.appendChild(empty);
          suggestions.hidden = false;
          return;
        }

        matches.forEach((item) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'page-search-suggestion';
          button.textContent = item.title;
          button.addEventListener('click', () => {
            input.value = item.title;
            setVisible();
            suggestions.hidden = true;
            focusMatch(item.card);
          });
          suggestions.appendChild(button);
        });
        suggestions.hidden = false;
      };

      input.addEventListener('input', () => {
        setVisible();
        renderSuggestions();
      });

      input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          executeSearch();
        } else if (event.key === 'Escape' && suggestions) {
          suggestions.hidden = true;
        }
      });

      input.addEventListener('focus', renderSuggestions);

      document.addEventListener('click', (event) => {
        if (wrap && !wrap.contains(event.target) && suggestions) suggestions.hidden = true;
      });
    });

    const buttons = root.querySelectorAll ? root.querySelectorAll('[data-page-product-search-submit]') : [];
    buttons.forEach((button) => {
      if (button.dataset.pageSearchSubmitBound === 'true') return;
      button.dataset.pageSearchSubmitBound = 'true';
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const input = button.closest('.collection-page-search, .search-page-inline-tools')?.querySelector('[data-page-product-search]');
        if (!input) return;
        if (typeof input.sevenRealmsRunPageSearch === 'function') {
          input.sevenRealmsRunPageSearch();
        } else {
          input.dispatchEvent(new Event('input', { bubbles: true }));
        }
        input.focus({ preventScroll: true });
      });
    });
  }

  function initProductsPerPage(root = document) {
    const selects = root.querySelectorAll ? root.querySelectorAll('[data-products-per-page]') : [];
    selects.forEach((select) => {
      if (select.dataset.productsPerPageBound === 'true') return;
      select.dataset.productsPerPageBound = 'true';

      Array.from(select.options).forEach((option) => {
        if (option.value === '200') option.remove();
      });

      select.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.delete('page');
        url.searchParams.delete('per_page');
        if (select.value === '50') {
          url.searchParams.set('view', '48');
        } else if (url.searchParams.get('view') === '48') {
          url.searchParams.delete('view');
        }
        window.location.href = url.toString();
      });
    });
  }

  function refreshCartUi() {
    // Launch-safe collection/search card behavior:
    // update header totals only. Do not render/open cart drawer or cart
    // notification from grid cards; those section re-renders were corrupting
    // cart UI after repeated adds.
    const syncPromise = window.InnerNerdCartSync && typeof window.InnerNerdCartSync.refresh === 'function'
      ? window.InnerNerdCartSync.refresh()
      : fetch('/cart.js')
        .then((response) => response.json())
        .then((cart) => {
          if (window.InnerNerdCartSync && typeof window.InnerNerdCartSync.update === 'function') {
            window.InnerNerdCartSync.update(cart);
          }
          return cart;
        });

    Promise.resolve(syncPromise)
      .then(() => {
        if (typeof window.updateStickyCart === 'function') {
          window.updateStickyCart();
        }
      })
      .catch(() => {});
  }

  document.addEventListener('DOMContentLoaded', () => {
    initCollectionProductCards();
    initProductsPerPage();
  });
  document.addEventListener('shopify:section:load', (event) => {
    initCollectionProductCards(event.target);
    initProductsPerPage(event.target);
  });
  document.addEventListener('collectionProductsLoaded', (event) => {
    initCollectionProductCards(event.detail?.container || document);
    initProductsPerPage(event.detail?.container || document);
  });
})();

// Reinitialize when new products are loaded via infinite scroll

